import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PaveService } from '../../services/pave.service';

@Injectable()
export class PavesResolver implements Resolve<Observable<string>> {

  constructor(
    private paveService: PaveService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    return this.paveService.get().pipe(map(
      (res) => {
        return JSON.stringify(res);
      }),
      catchError(err => {
        return empty();
      }
    ));
  }

}
